/**
 * @generated SignedSource<<b74eb013efca86a149418f101e209f7b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type JobStatus = "CLOSED" | "EXPIRED" | "IN_REVIEW" | "PENDING_REVISION" | "POSTED" | "PRIVATE" | "REJECTED" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type useBoostedJobs_job$data = {
  readonly boostRemainingDays: number | null;
  readonly boostRequested: boolean;
  readonly expertProgram: {
    readonly id: string;
  } | null;
  readonly id: string;
  readonly status: JobStatus;
  readonly " $fragmentType": "useBoostedJobs_job";
};
export type useBoostedJobs_job$key = {
  readonly " $data"?: useBoostedJobs_job$data;
  readonly " $fragmentSpreads": FragmentRefs<"useBoostedJobs_job">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "useBoostedJobs_job",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "boostRequested",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "boostRemainingDays",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ExpertProgram",
      "kind": "LinkedField",
      "name": "expertProgram",
      "plural": false,
      "selections": [
        (v0/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "type": "Job",
  "abstractKey": null
};
})();

(node as any).hash = "83ae6b0cc8e74aa1457f7ecac9839283";

export default node;
